import { createApi } from "@reduxjs/toolkit/query/react";

import { API_BASE_URL } from "../../utils/constants";
import { axiosBaseQuery } from "../baseQuery";
import { TargetGetListResponse } from "../types/target";
import targetParser from "../parser/targetParser";

export const targetApis: any = createApi({
  reducerPath: "targetApi",
  baseQuery: axiosBaseQuery({ baseUrl: API_BASE_URL }),
  tagTypes: ["TARGET", "ISAPPROVED"],

  endpoints: (builder) => ({
    getTargetList: builder.query({
      query: (params: any) => {
        return {
          url: "/target-achievement-tab",
          method: "GET",
          params: params,
        };
      },
      providesTags: ["TARGET"],
      transformResponse: (response: any) => {
        return targetParser.getTabs(response);
      },
    }),
    getTargetAchievement: builder.query({
      query: (params: any) => {
        return {
          url: "/target-achievement",
          method: "GET",
          params: params,
        };
      },
      providesTags: ["TARGET", "ISAPPROVED"],
      transformResponse: (response: any) => {
        return targetParser.getTargetAchievement(response);
      },
    }),
    approveData: builder.mutation({
      query: (payload: any) => {
        return {
          url: "/target-achievement-tab/approve",
          method: "POST",
          data: payload,
        };
      },  
      invalidatesTags: ["ISAPPROVED"],
    }),
    
    tableHeaderDataById: builder.query({
      query: (id: any) => {
        return {
          url: `/target-achievement-tab/table-headers/${id}`,
          method: "GET",
        };
      },
      providesTags: ["TARGET"],
      transformResponse: (response: any) => {
        return targetParser.getTableHeaderDataById(response);
      },
    }),
    dataInputImport: builder.mutation({
      query: (payload: any) => {
        return {
          url: "/target-achievement",
          method: "POST",
          data: payload,
        };
      },
      invalidatesTags: ["TARGET"],
    }),
    
    sixerClassUpload: builder.mutation({
      query: (payload: any) => {
        return {
          url: "/target-achievement/upload",
          method: "POST",
          data: payload,
          // contentType: "MultiPart"
        };
      },
      invalidatesTags: ["TARGET"],
    }),

    deleteDataInput: builder.mutation({
      query: (targetAchievementTabId: any) => {
        return {
          url: `/target-achievement/${targetAchievementTabId}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["TARGET"],
    }),

  }),
});

export const {
  useGetTargetListQuery,
  useGetTargetAchievementQuery,
  useLazyGetTargetAchievementQuery,
  useApproveDataMutation,
  useLazyTableHeaderDataByIdQuery,
  useDataInputImportMutation,
  useDeleteDataInputMutation,
  useSixerClassUploadMutation
} = targetApis;
